import {Buffer} from 'buffer'

/**
 * @param {string} [jwt] 
 */
function decodeJWT (jwt)
{
    if (!jwt) return null
    jwt = jwt.replace(/-/g, '+').replace(/_/g, '/')

    try
    {
        const parts = jwt.split('.')
        const header = JSON.parse(Buffer.from(parts[0], 'base64'))
        const payload = JSON.parse(Buffer.from(parts[1], 'base64'))
        const signature = Buffer.from(parts[2], 'base64')
        const issuedDate = new Date(payload.iat * 1000)
        const expirationDate = new Date(payload.exp * 1000)

        return { header, payload, signature, issuedDate, expirationDate }
    }
    catch (e)
    {
        console.log(e)

        return null
    }
}

export default { decodeJWT }


// WEBPACK FOOTER //
// ./src/utils/authUtils.js